/* ==========================================================================
  filters.js
========================================================================== */

/**
 * Polyfill includes
 */
 if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';

    if (search instanceof RegExp) {
      throw TypeError('first argument must not be a RegExp');
    }
    if (start === undefined) { start = 0; }
    return this.indexOf(search, start) !== -1;
  };
}

/**
 * Hierarchy menu with lodash
 */
var cor_hierarchy_menu = function(args) {

  var original_id = 0,
      menu_container = args.menu_container,
      menu_items = args.menu_items;

  /**
   * Switch screens on click to <button class="screen-switcher">
   */

  menu_container.addEventListener('click', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('screen-switcher')){
      var target_id = parseInt(e.target.getAttribute('data-id'));
      // console.log('target-id', target_id);
      var direction = 'to-right';
      if (e.target.classList.contains('to-left')) {
        direction = 'to-left';
      }
      render_menu_for_id(target_id, direction, e.currentTarget);
    }
  });

  /**
   * Render prev/first component of navigation
   */

  function get_navigation_html(response) {
    var current = response.current;
    var parent = response.top;
    var html = '';
    if (current.parent > -1) {
      html += '<div class="filterable__hierarchy__screen__nav">';
        html += '<button type="button" class="screen-switcher to-left prev" data-id="' + parent.parent + '">' + theme_strings_index.previous + '</button>';
      html += '</div>';
    }
    return html;
  }


  /**
   * Render <a> component from item (with button to next level)
   */

  function get_item_html(item, isParentItem) {
    var output = '';

    var title = item.title;
    if (isParentItem) {
      title = theme_strings_index.all + ' ' + title;
    }

    var activeClass = '';

    if (has_children(item.id) && !isParentItem) {

      if (item.is_active || item.is_active_parent) {
        activeClass = 'is-active-parent';
      }

      output += '<button type="button" aria-label="' + title + ', ' + theme_strings_index.children + '" class="filterable__hierarchy__item filterable__hierarchy__item--switch screen-switcher to-right ' + activeClass + '" data-id="' + item.id + '">' + title +  '</button>';
    } else {

      if (item.is_active) {
        activeClass = 'is-active';
      } else if (item.is_active_parent) {
        activeClass = 'is-active-parent';
      }

      var actionClass = 'js-filterable-option';
      if (item.is_active) {
        actionClass = 'js-filterable-selection';
      }

      var aria_label = '';
      if (item.is_active) {
        aria_label = 'aria-label="' + theme_strings_index.active_before + ': ' + title + ', ' + theme_strings_index.active_after + '"';
      }

      output += '<button type="button" ' + aria_label + ' class="filterable__hierarchy__item filterable__hierarchy__item--option ' + activeClass + ' ' + actionClass + '" data-name="' + item.name + '" data-value="' + item.slug + '">' + title + '</a>';

    }
    return output;
  }

  /**
   * Render the <ul> component with items (children and siblings)
   */

  function get_ul_markup(response) {
    var html = '';
    html += '<ul>';
    if (response.top.id > 0) {
      html += '<li class="menu-item-' + response.top.id + '">' + get_item_html(response.top, true) + '</li>';
    }
    for (var i = 0; i < response.items.length; i++) {
      var item = response.items[i];
      html += '<li class="menu-item-' + item.id + '">' + get_item_html(item, false) + '</li>';
    }
    html += '</ul>';
    return html;
  }

  /**
   * Render menu for given id, direction to-right/to-left (is this parent or sub)
   */
  function render_menu_for_id(id, direction, menu_container) {

    // console.log('render_menu_for_id => start with id:', id);

    // maybe get fallback id for given id
    var item = get_item(id);
    if (has_children(id)) {
      var id = item.id;
    } else {
      var id = item.parent;
    }
    var id = item.id;

    // console.log('render_menu_for_id => after item fetch:', id);

    // figure out if this should return children or parents
    var response = get_relevant_items_for_id(id);

    // container
    var html = '<div class="filterable__hierarchy__screen">';

    // get prev / beginning navigation
    html += get_navigation_html(response);

    // Render <ul>
    html += get_ul_markup(response);

    // close container
    html += '</div>';

    var el = html_str_to_el(html);

    // console.log('render_menu_for_id', id, item, response, html, el);

    // Highlight current menu item
    if (el.querySelector('.menu-item-' + original_id)) {
      el.querySelector('.menu-item-' + original_id).classList.add('current-menu-item');
    }

    // Animate and append
    menu_container.classList.add('disappear');
    menu_container.classList.add(direction);
    setTimeout(function(menu_container, el) {
      menu_container.innerHTML = el.outerHTML;
      menu_container.classList.remove('disappear');
      menu_container.classList.remove('to-left');
      menu_container.classList.remove('to-right');
    }, 200, menu_container, el);

  }

  /**
   * Get relevant menu items for given id (children or siblings)
   */

  function get_relevant_items_for_id(id) {
    if (has_children(id)) {
      var items = {
        'type' : 'children',
        'top' : get_item(id),
        'current' : get_item(id),
        'items' : _.filter(menu_items, { 'parent': id })
      };
      return items;
    }
    else {
      var item = get_item(id);
      var items = {
        'type' : 'same-level',
        'top' : get_parent(id),
        'current' : get_item(id),
        'items' : _.filter(menu_items, { 'parent': item.parent })
      };
      return items;
    }
    return false;
  }

  /**
   * Has given menu item a parent true/false
   */

  function has_parent(id) {
    var current = _.filter(menu_items, { 'id': id });
    if (current.length) {
      if (current[0].parent == 0) {
        return false;
      }
    }
    return true;
  }

  /**
   * Has given menu item children true/false
   */

  function has_children(id) {
    var children = _.filter(menu_items, { 'parent': id });

    // console.log('has_children', id, children.length);
    if (children.length) {
      return true;
    }
    return false;
  }

  /**
   * Get item by id
   */
  function get_item(id) {
    var current = _.filter(menu_items, { 'id': id });
    // console.log('get_item', id, current, menu_items);
    if (current.length) {
      return current[0];
    }
    var base = _.filter(menu_items, { 'parent': 0 });
    if (base.length) {
      return base[0];
    }
    return false; // item not found for ID
  }

  /**
   * Get parent by id
   */

  function get_parent(id) {
    if (has_parent(id)) {
      var item = get_item(id);
      var parent = _.filter(menu_items, { 'id': item.parent });
      if (parent.length) {
        return parent[0];
      }
    }
    return false; // item not found for ID
  }

  /**
   * HTML string to element
   */
  function html_str_to_el(html) {
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.firstChild;
  }

  /**
   * Get icon from icon storage
   */
  function get_icon_markup(name) {

    var icon = document.querySelector('.js-header-svg-storage .icon-' + name);
    return (icon) ? icon.outerHTML : '-';

  }

  /**
   * Render initial menu
   */
  render_menu_for_id(original_id, 'to-right', menu_container);

};

// Observer for changes in passed mutations childs, add class and amount as dataset.
var observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    mutation.target.dataset.amount = " +" + (mutation.target.childNodes.length - 1);
    if (mutation.target.childNodes.length > 1) {
      mutation.target.classList.add('overflow');
    } else {
      mutation.target.classList.remove('overflow');
    }
  });
});

/**
 * @see https://gomakethings.com/how-to-get-the-closest-parent-element-with-a-matching-selector-using-vanilla-javascript/
 */
function cor_get_parent(elem, selector) {
  // Element.matches() polyfill
  if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        function(s) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                i = matches.length;
            while (--i >= 0 && matches.item(i) !== this) {}
            return i > -1;
        };
  }
  // Get the closest matching element
  for ( ; elem && elem !== document; elem = elem.parentNode ) {
    if ( elem.matches( selector ) ) {
      return elem;
    }
  }
  return null;
}

/**
 * Popular tags: determine overflow, can be left, right or both directions
 */
var determine_popular_overflow = function(content, container) {

  var containerMetrics = container.getBoundingClientRect();
  var containerMetricsLeft = Math.floor(containerMetrics.left);
  var containerMetricsRight = Math.floor(containerMetrics.right);

  var contentMetrics = content.getBoundingClientRect();
  var contentMetricsLeft = Math.floor(contentMetrics.left);
  //  calculate contentMetricsRight this way because ie would calculate contentMetrics.right wrong for some reason
  var contentMetricsRight = content.scrollWidth + contentMetricsLeft - 1;

if (containerMetricsLeft > contentMetricsLeft && containerMetricsRight < contentMetricsRight) {
      return "both";
  } else if (contentMetricsLeft < containerMetricsLeft) {
      return "left";
  } else if (contentMetricsRight > containerMetricsRight) {
      return "right";
  } else {
      return "none";
  }

};

/**
 * Ajaxify numbered pagination
 */
function cor_numbered_pagination_hooks() {
  var replace_history;
  var numbered_pagination_items;
  var numbered_paginations = document.querySelectorAll('.js-numbered-pagination');
  if (numbered_paginations.length) {
    for (var i = 0; i < numbered_paginations.length; i++) {
      if (numbered_paginations[i].getAttribute('data-replace-history') == '0' || numbered_paginations[i].getAttribute('data-replace-history') == 0) {
        replace_history = false;
      } else {
        replace_history = true;
      }
      numbered_pagination_items = numbered_paginations[i].querySelectorAll('a');
      for (var j = 0; j < numbered_pagination_items.length; j++) {
        numbered_pagination_items[j].addEventListener('click', function(e) {
          e.preventDefault();
          // get items via ajax
          cor_filter_ajax({
            url: e.currentTarget.getAttribute('href'),
            type: 'filter',
            replaceHistory: replace_history,
            container: cor_get_parent(e.currentTarget, '[data-cor-ajax-container]')
          });
          // scroll to container
          var container = cor_get_parent(e.currentTarget, '.js-ajax-container');
          if (container && typeof container.scrollIntoView == 'function') {
            container.scrollIntoView();
          }
        });
      }
    }
  }
}

var get_parent_with_class = function (el, css_class) {
  var ancestor = el.parentElement;
  while (ancestor.parentElement && ancestor.classList) {
    if (ancestor.classList.contains(css_class)) {
      return ancestor;
    }
    ancestor = ancestor.parentElement;
  }
  return false;
}

function cor_filters( container ) {

  var form   = container.querySelector('.js-filters');
  var submit = container.querySelector('.js-filters-submit');
  var reset  = container.querySelector('.js-search-reset');

  if ( ! form ) {
    return;
  }

  /**
   * Reset button
   */
  if (reset) {
      reset.addEventListener('click', function(e) {
        e.preventDefault();
        var form = container.querySelector('.js-filters');
        var replace_history = true;
        if (form.getAttribute('data-replace-history') == '0' || form.getAttribute('data-replace-history') == 0) {
          replace_history = false;
        }
        cor_filter_ajax({
          url: reset.getAttribute('href'),
          type: 'filter',
          replaceHistory: replace_history,
          container: cor_get_parent(form, '[data-cor-ajax-container]')
        });
    });
  }

  /**
   * Form hooks
   */
  if (form) {
    form.addEventListener('submit', function(e) {

      var form = e.currentTarget;
      var url = form.action;
      var get_vars = form_serialize(form);

      console.log('form submit', form, url, get_vars);

      /**
       * Force empty items to be included in url if filterable item has this option activated.
       * This is used in tax archives so that queried object can be overridden with all items.
       */
      var filterables = form.querySelectorAll('.js-filterable');
      for (var i = 0; i < filterables.length; i++) {

        var filterable_name = filterables[i].getAttribute('data-name');
        var filterable_force_empty = filterables[i].getAttribute('data-force-empty');

        if (filterable_name && filterable_force_empty == 'true' && get_vars.indexOf(filterable_name) < 0 ) {
          if (get_vars.length > 0) {
            get_vars += '&';
          }
          // remove array structure [] for easier processing in PHP
          var simplified_filterable_name = filterable_name.replace(/\[\]$/, '');
          get_vars += simplified_filterable_name + '=';
        }

      }


      // add get parameter from_site if exists in current url
      var url_parameters = new URLSearchParams(window.location.search);
      if (url_parameters.has('from_site')) {
        if (get_vars.length > 0) {
          get_vars += '&';
        }
        get_vars += 'from_site=' + url_parameters.get('from_site');
      }

      if (get_vars && get_vars.length) {
        url = url + '?' + get_vars;
      }

      // update browser history
      var replace_history = true;
      if (form.getAttribute('data-replace-history') == '0' || form.getAttribute('data-replace-history') == 0) {
        replace_history = false;
      }

      cor_filter_ajax({
        url: url,
        type: 'filter',
        replaceHistory: replace_history,
        container: cor_get_parent(form, '[data-cor-ajax-container]'),
      });
      e.preventDefault();

    });
  }

  /**
   * Numbered pagination hooks
   */
  if (typeof cor_numbered_pagination_hooks === 'function') {
    cor_numbered_pagination_hooks();
  }

  function filters_set_input_state(that) {
    var container = cor_get_parent(that, '.js-filters__search');
    if (container) {

      if (that.value && that.value.length) {
        container.classList.add('filters__input--has-value');
      } else {
        container.classList.remove('filters__input--has-value');
      }

    }
  }

  /**
   * Reset buttons
   */
   var resetable_inputs = form.querySelectorAll('.js-filters__search');
   if (resetable_inputs.length) {
    var resetable_input;
    for (var i = resetable_inputs.length - 1; i >= 0; i--) {
      if (resetable_inputs[i].querySelector('input')) {
        resetable_inputs[i].querySelector('input').addEventListener('change', function(e) {
          filters_set_input_state(this);
        });
        resetable_inputs[i].querySelector('input').addEventListener('keyup', function(e) {
          filters_set_input_state(this);
        });
        filters_set_input_state(resetable_inputs[i]);
      }
    }
   }

   var reset_buttons = form.querySelectorAll('.js-filters__reset');
   if (reset_buttons) {
    var reset_button;
    for (var i = reset_buttons.length - 1; i >= 0; i--) {
      reset_buttons[i].addEventListener('click', function(e) {
        var container = cor_get_parent(this, '.js-filters__search');
        if (container) {
          container.querySelector('input').value = '';
          filters_set_input_state(container.querySelector('input'));
        }
      });
    }
   }

   function scrollToEl(el) {
    var isMobile = window.innerWidth < 720;
    var offset = isMobile ? 38 : 128;
    if (isMobile && document.body.classList.contains('is-sub-site')) {
      offset = 88;
    }
    if (window.scrollTo) {
      // mobile phone needs a little delay
      setTimeout(function(element){
        window.scrollTo({
          top: element.getBoundingClientRect().top + window.scrollY - offset,
          behavior: 'smooth'
        });
      //   el.scrollIntoView({
      //     behavior: 'smooth', // Smooth scrolling
      //     block: 'start'      // Align to the top of the viewport
      //  });
      }, 100, el);
    }
   };


  function input_focus(el) {

    // remove already focused
    var already_focused = document.querySelectorAll('.filters__input--focus');
    if (already_focused.length) {
      for (var i = already_focused.length - 1; i >= 0; i--) {
        already_focused[i].classList.remove('filters__input--focus');
      }
    }

    var parent = cor_get_parent(el, '.js-filters__input');
    if (parent) {
      parent.classList.add('filters__input--focus');
    }
    scrollToEl(el);
  }

  function input_blur(el) {

    // return if has class "open"
    if (el.classList.contains('open')) {
      return;
    }

    // skip blur if child is active
    for (var i = 0; i < el.childNodes.length; i++) {
      if (el.childNodes[i] == document.activeElement) {
        return;
      }
    }

    var parent = cor_get_parent(el, '.js-filters__input');
    if (parent) {
      parent.classList.remove('filters__input--focus');
    }
  }

  /**
   * Filterable "init" function
   */
  function init_filterable( container) {

    var filterables = container.querySelectorAll('.js-filterable');
    for (var i = 0; i < filterables.length; i++) {

      var filterable        = filterables[i];
      var input             = filterable.querySelector('.js-filterable-input');
      var values            = filterable.querySelector('.js-filterable-values');
      var caret             = filterable.querySelector('.js-filterable-caret');
      var reset             = filterable.querySelector('.js-filterable-reset');
      var options           = filterable.querySelectorAll('.js-filterable-option');
      var selectionButtons  = filterable.querySelectorAll('.js-filterable-selection');

      /**
       * Init hierarchy
       */
      var hierarchy = filterable.querySelector('.js-filterable-hierarchy');
      if (hierarchy) {
        var options = filterable.getAttribute('data-options');
        cor_hierarchy_menu({
          menu_container: hierarchy,
          menu_items: JSON.parse(decodeURIComponent(options))
        });

      }

      /**
       * Open on click
       */

      filterable.addEventListener('click', function(e) {

        var filterable = e.currentTarget;

        /**
         * Click on active filter: remove filter
         */
        if (e.target.classList && e.target.classList.contains('js-filterable-selection')) {

          var button = e.target;
          var value = button.getAttribute('data-value');
          var inputs = filterable.querySelectorAll('.js-filterable-values input');
          for (var k = 0; k < inputs.length; k++) {
            if (inputs[k].value == value) {
              inputs[k].parentNode.removeChild(inputs[k]);

              // override prefiltered selection with "show all"
              if (filterable.getAttribute('data-allow-prefiltered-override') === 'true' && inputs.length == 1) {
                var allInput = document.createElement('input');
                allInput.setAttribute('name', inputs[k].getAttribute('name'));
                allInput.setAttribute('value', '-1');
                allInput.setAttribute('type', 'hidden');
                filterable.querySelector('.js-filterable-values').appendChild(allInput);
              }

              var ajaxContainer = cor_get_parent(button, '[data-cor-ajax-container]');

              var submit = ajaxContainer.querySelector('.js-filters-submit');
              if (submit) {

                // fire ajax
                submit.click();

                // close menu
                setTimeout(function(filterable){
                  filterable.setAttribute('aria-expanded', 'false');
                }, 50, filterable);

                // hide this button
                var buttonInstances = filterable.querySelectorAll('.js-filterable-selection[data-value="' + button.getAttribute('data-value') + '"]');
                for (var j = 0; j < buttonInstances.length; j++) {
                  var button = buttonInstances[j];
                  button.classList.add('is-loading-hidden');
                }

                e.preventDefault();
                e.stopPropagation();

              }
            }
          }

          return;
        }

        /**
         * Click on option: add filter
         */
        if (e.target.classList && e.target.classList.contains('js-filterable-option')) {
          var option = e.target;
          var name = option.getAttribute('data-name');
          var value = option.getAttribute('data-value');
          var valueContainer = filterable.querySelector('.js-filterable-values');
          if (valueContainer) {

            // remove empty value (-1) brefore adding new
            var emptyInput = valueContainer.querySelector('input[value="-1"]');
            if (emptyInput) {
              emptyInput.parentNode.removeChild(emptyInput);
            }

            var input = document.createElement('input');
            input.setAttribute('name', name);
            input.setAttribute('value', value);
            input.setAttribute('type', 'hidden');
            valueContainer.appendChild(input);

            var ajaxContainer = cor_get_parent(input, '[data-cor-ajax-container]');

            // Trigger custom event and pass name and value
            var event = new CustomEvent('cor_filterable_option_selected', {
              detail: {
                name: name,
                value: value
              }
            });
            window.dispatchEvent(event);

            var submit = ajaxContainer.querySelector('.js-filters-submit');
            if (submit) {
              submit.click();
              setTimeout(function(filterable){
                filterable.setAttribute('aria-expanded', 'false');
              }, 50, filterable)
            }
          }

        }

        // close others
        var filterable = e.currentTarget;

        var filterables = document.querySelectorAll('.js-filterable');
        for (var i = 0; i < filterables.length; i++) {
          if (filterable.isEqualNode(filterables[i])) {
            filterable.setAttribute('aria-expanded', 'true');
            scrollToEl(filterable);
          } else {
            filterables[i].setAttribute('aria-expanded', 'false');
            // console.log('Filterable: close others on click', e);
          }
        }
      });


      /**
       * Set "aria-expanaded" true when text input is focused
       */
      input.addEventListener('focus', function(e) {

        // close others
        var filterable = get_parent_with_class(e.currentTarget, 'js-filterable');

        if (filterable) {
          var filterables = document.querySelectorAll('.js-filterable');
          for (var i = 0; i < filterables.length; i++) {
            if (filterable.isEqualNode(filterables[i])) {
              filterable.setAttribute('aria-expanded', 'true');
            } else {
              filterables[i].setAttribute('aria-expanded', 'false');
              // console.log('Filterable: close on input focus', e);
            }
            // filterable.scrollIntoView();
          }

        }

      });

      /**
       * Close on caret click
       */
      caret.addEventListener('click', function(e) {
        var filterable = get_parent_with_class(e.currentTarget, 'js-filterable');
        if (filterable) {
          filterable.setAttribute('aria-expanded', 'false');
          // console.log('Filterable: close on caret click', e);
          e.preventDefault();
          e.stopPropagation();
        }
      });

      /**
       * Reset
       */
       reset.addEventListener('click', function(e) {
         var reset = e.currentTarget;
         var filterable = get_parent_with_class(e.currentTarget, 'js-filterable');
         if (filterable) {
           var input = filterable.querySelector('.js-filterable-input');
           if (input) {
             input.value = '';
             input.setAttribute('value', '');
             filterable.setAttribute('data-type', 'options');
           }
         }
       });

      /**
       * Enter button
       */
      input.addEventListener('keydown', function(e) {

        var filterable = get_parent_with_class(e.currentTarget, 'js-filterable');

        if (filterable) {

          if (e.key === "Enter") {
            e.preventDefault();
            var firstResult = filterable.querySelector('.is-result');
            if (firstResult) {
              firstResult.click();
            }
          }

          if (e.key === "Down" || e.key === "ArrowDown") {
            e.preventDefault();
            var firstResult = filterable.querySelector('.js-filterable-dropdown button');
            if (firstResult) {
              firstResult.focus();
            }
          }


        }



      });

      /**
       * Input typing
       */
      input.addEventListener('keyup', function(e) {
        var input = e.currentTarget;
        var filterable = get_parent_with_class(e.currentTarget, 'js-filterable');

        if (!filterable) {
          return;
        }

        if (input.value.length > 0) {
          filterable.setAttribute('data-type', 'search');

          var searchQuery = input.value.toLowerCase();
          var index = [];
          var items = filterable.querySelectorAll('.js-filterable-search-result');
          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item.getAttribute('data-index') && item.getAttribute('data-index') !== '') {
              index.push({
                item: item,
                data: item.getAttribute('data-index')
              });
            }
          }

          if (searchQuery && searchQuery !== '') {
            for (var i = 0; i < index.length; i++) {
              var record = index[i];
              if (record.data.includes(searchQuery)) {
                // console.log(searchQuery, record.data);
                record.item.classList.remove('is-not-result');
                record.item.classList.add('is-result');
                var label = record.item.getAttribute('data-label');
                var pos = record.data.indexOf(searchQuery);
                // highlight matched part
                if (pos >= 0) {
                  record.item.innerHTML = label.substring(0, pos) + "<span class='match'>" + label.substring(pos,pos+searchQuery.length) + "</span>" + label.substring(pos + searchQuery.length);
                }
              } else {
                record.item.classList.add('is-not-result');
                record.item.classList.remove('is-result');
                record.item.innerHTML = record.item.getAttribute('data-label');
              }
            }
          } else {

            for (var i = 0; i < index .length; i++) {
              var record = index[i];
              record.item.classList.remove('is-not-result');
              record.item.classList.add('is-result');
              record.item.innerHTML = record.item.getAttribute('data-label');
            }

          }

          // show none message if nothing found
          if (filterable.querySelectorAll('.is-result').length > 0) {
            filterable.classList.remove('has-no-search-results');
          } else {
            filterable.classList.add('has-no-search-results');
          }

        } else {
          filterable.setAttribute('data-type', 'options');
        }

      });

    }

  }
  init_filterable( container );

  /**
   * Close filterables on outside click
   */
  document.addEventListener('click', function(e) {
    var filterable = get_parent_with_class(e.target, 'js-filterable');
    if (!filterable && !(e.target.classList && e.target.classList.contains('js-filterable'))) {
      var filterables = document.querySelectorAll('.js-filterable');
      for (var i = 0; i < filterables.length; i++) {
        filterables[i].setAttribute('aria-expanded', 'false');
      }
      // console.log('Filterable: close on outside click', e);
    }
  });
  /**
   * Close filterables on ESC
   */
  document.addEventListener('keyup', function(e) {
    if (e.key === "Escape") {
      var filterables = document.querySelectorAll('.js-filterable');
      if (filterables.length) {
        for (var i = 0; i < filterables.length; i++) {
          filterables[i].setAttribute('aria-expanded', 'false');
        }
        console.log('Filterable: close on ESC', e);
      }
    }
  });

  /**
   * Search
   */
   var search = container.querySelector('.js-filter-search');
   if (search) {
    search.addEventListener('focus', function() {
      input_focus(this);
    });
    search.addEventListener('blur', function() {
      input_blur(this);
    });
    search.addEventListener('keyup', function(e) {
      if (this.value == '') {
        var ajaxContainer = cor_get_parent(e.currentTarget, '[data-cor-ajax-container]');
        var submit = ajaxContainer.querySelector('.js-filters-submit');
        if (submit) {
          submit.click();
        }
      }
    });
   }

   var additional_toggle = document.querySelector('.js-filters-additiona-toggle');
   if (additional_toggle) {
    additional_toggle.addEventListener('click', function(e) {
      e.currentTarget.parentNode.parentNode.classList.toggle('is-open');
      if (e.currentTarget.getAttribute('aria-expanded') == 'true') {
        e.currentTarget.setAttribute('aria-expanded', 'false');
      } else {
        e.currentTarget.setAttribute('aria-expanded', 'true');
      }
    });
   }

  /**
   * Formats
   */
   var format_radios = form.querySelectorAll('.js-filters__radio__input');
   if (format_radios.length) {
    for (var i = format_radios.length - 1; i >= 0; i--) {
      format_radios[i].addEventListener('change', function() {

        var sub_format_radios = form.querySelectorAll('.js-filters__radio__input');

        // this is not "all", uncheck "all"
        if (this.value.length > 0) {
          for (var j = sub_format_radios.length - 1; j >= 0; j--) {
            if (sub_format_radios[j].value.length == 0) {
              sub_format_radios[j].checked = false;
            }
          }
        }

        // this is "all", uncheck all else
        if (this.value.length === 0) {
          for (var j = sub_format_radios.length - 1; j >= 0; j--) {
            if (sub_format_radios[j].value.length > 0) {
              sub_format_radios[j].checked = false;
            }
          }
        }

        // get results
        submit.click();

      });
    }
   }

  /**
   * Filter toggle on mobile
   */

  var filter_toggle_office_employees = document.querySelector('.js-office-employees-filter-toggle');
  if (filter_toggle_office_employees) {
    filter_toggle_office_employees.addEventListener('click', function(e) {
      e.preventDefault();
      var office_employees = document.querySelector('.js-office-employees');
      if (office_employees) {
        office_employees.classList.add('is-open-office-employees');
      }
    });
  }

};

/**
 * Init popular filters
 */
var cor_popular_filters = function() {

  var ajax_containers = document.querySelectorAll('[data-cor-ajax-container]');

  if (ajax_containers.length === 0) {
    return;
  }

  for (var i = 0; i < ajax_containers.length; i++) {

    /**
     * Scroll handler
     */

      var leftArrow    = ajax_containers[i].querySelector('.js-filters-popular-left');
      var rightArrow   = ajax_containers[i].querySelector('.js-filters-popular-right');
      var navWrapper   = ajax_containers[i].querySelector('.js-filters-popular-wrapper');
      var navContainer = ajax_containers[i].querySelector('.js-filters-popular-container');
      var navItems     = ajax_containers[i].querySelector('.js-filters-popular-items');
      var navLinks     = ajax_containers[i].querySelectorAll('.js-filters-popular-item');

      if (leftArrow && rightArrow && navWrapper && navContainer && navItems && navLinks.length > 0) {

        navContainer.setAttribute("data-overflowing", determine_popular_overflow(navItems, navContainer));
        navWrapper.setAttribute("data-overflowing", determine_popular_overflow(navItems, navContainer));

        /**
         * Ajaxify links
         */
        for (var j = 0; j < navLinks.length; j++) {
          var navLink = navLinks[j];
          navLink.addEventListener('click', function(e) {

            e.preventDefault();
            e.currentTarget.classList.add('is-active');
            var ajaxContainer = document.querySelector('.js-ajax-container');
            if (ajaxContainer) {
              var replace_history = true;
              if (ajaxContainer.getAttribute('data-replace-history') == '0' || ajaxContainer.getAttribute('data-replace-history') == 0) {
                replace_history = false;
              }
              cor_filter_ajax({
                url: e.currentTarget.getAttribute('href'),
                type: 'filter',
                replaceHistory: replace_history,
                container: cor_get_parent(e.currentTarget, '[data-cor-ajax-container]')
              });
            }

          });
        }

        window.addEventListener("resize", function() {
          setTimeout(function () {
            var navItems = document.querySelector('.js-filters-popular-items');
            var navWrapper = document.querySelector('.js-filters-popular-wrapper');
            var navContainer = document.querySelector('.js-filters-popular-container');
            if (navWrapper && navContainer && navItems) {
              navContainer.setAttribute("data-overflowing", determine_popular_overflow(navItems, navContainer));
              navWrapper.setAttribute("data-overflowing", determine_popular_overflow(navItems, navContainer));
            }
          }, 500);
        });


        // handle the scroll of the horizontal container
        navContainer.addEventListener('scroll', function(e) {
          var navContainer = e.currentTarget;
          var navWrapper = get_parent_with_class(navContainer, 'js-filters-popular-wrapper');
          var navContainer = navWrapper.querySelector('.js-filters-popular-container');
          if (navContainer.getAttribute('data-ticking') !== 'true') {
              window.requestAnimationFrame(function() {
                var navItems = document.querySelector('.js-filters-popular-items');
                var navContainer = document.querySelector('.js-filters-popular-container');
                navContainer.setAttribute("data-overflowing", determine_popular_overflow(navItems, navContainer));
                navWrapper.setAttribute("data-overflowing", determine_popular_overflow(navItems, navContainer));
                navContainer.setAttribute('data-ticking', 'false');
              });
          }
          navContainer.setAttribute('data-ticking', 'true');
        });

        leftArrow.addEventListener("click", function(e) {

          var leftArrow = e.currentTarget;
          var navWrapper = get_parent_with_class(leftArrow, 'js-filters-popular-wrapper');
          var navContainer = navWrapper.querySelector('.js-filters-popular-container');
          var navItems = navWrapper.querySelector('.js-filters-popular-items');

          // if currently scrolling, return
          if (navContainer.getAttribute('data-is-moving') == true) {
              return;
          }
          // content overflowing both sides or on the left
          if (determine_popular_overflow(navItems, navContainer) === "left" || determine_popular_overflow(navItems, navContainer) === "both") {
              // find how far this panel has been scrolled
              var availableScrollLeft = navContainer.scrollLeft;
              // if the space available is less than two lots of our desired distance, just move the whole amount
              // otherwise, move by the amount in the settings
              if (availableScrollLeft < 220 * 2) {
                  navItems.style.transform = "translateX(" + availableScrollLeft + "px)";
              } else {
                  navItems.style.transform = "translateX(" + 220 + "px)";
              }
              // remove no-transition class to get the animation
              navItems.classList.remove("has-no-transition");
              // update settings
              navContainer.setAttribute('data-direction', 'left');
              navContainer.setAttribute('data-is-moving', 'true');
          }
          // update data-overflowing attribute
          navContainer.setAttribute("data-overflowing", determine_popular_overflow(navItems, navContainer));
          navWrapper.setAttribute("data-overflowing", determine_popular_overflow(navItems, navContainer));
        });

        // same as above but for the right arrow
        rightArrow.addEventListener("click", function(e) {

          var rightArrow = e.currentTarget;
          var navWrapper = get_parent_with_class(rightArrow, 'js-filters-popular-wrapper');
          var navContainer = navWrapper.querySelector('.js-filters-popular-container');
          var navItems = navWrapper.querySelector('.js-filters-popular-items');

          if (navContainer.getAttribute('data-is-moving') == 'true') {
              return;
          }
          if (determine_popular_overflow(navItems, navContainer) === "right" || determine_popular_overflow(navItems, navContainer) === "both") {

            //  calculate navBarRightEdge this way because ie would calculate navItems.getBoundingClientRect().right wrong for some reason
            var navBarRightEdge = navItems.scrollWidth + navItems.getBoundingClientRect().left;
            var navBarScrollerRightEdge = navContainer.getBoundingClientRect().right;
            var availableScrollRight = Math.floor(navBarRightEdge - navBarScrollerRightEdge);
            if (availableScrollRight < 220 * 2) {
                navItems.style.transform = "translateX(-" + availableScrollRight + "px)";
            } else {
                navItems.style.transform = "translateX(-" + 220 + "px)";
            }
            navItems.classList.remove("has-no-transition");
            navContainer.setAttribute('data-direction', 'right');
            navContainer.setAttribute('data-is-moving', 'true');
          }
          navContainer.setAttribute("data-overflowing", determine_popular_overflow(navItems, navContainer));
          navWrapper.setAttribute("data-overflowing", determine_popular_overflow(navItems, navContainer));
        });

        navItems.addEventListener("transitionend", function(e) {

          var navItems = e.currentTarget;
          var navWrapper = get_parent_with_class(navItems, 'js-filters-popular-wrapper');
          var navContainer = navWrapper.querySelector('.js-filters-popular-container');
          var navItems = navWrapper.querySelector('.js-filters-popular-items');

          // get the value of the transform, apply that to the current scroll position (so get the scroll pos first) and then remove the transform
          var styleOfTransform = window.getComputedStyle(navItems, null);
          var tr = styleOfTransform.getPropertyValue("-webkit-transform") || styleOfTransform.getPropertyValue("transform");
          // if there is no transition we want to default to 0 and not null
          var amount = Math.abs(parseInt(tr.split(",")[4]) || 0);
          navItems.style.transform = "none";
          navItems.classList.add("has-no-transition");
          // set scroll position
          if (navContainer.getAttribute('data-direction') == "left") {
            navContainer.scrollLeft = navContainer.scrollLeft - amount;
          } else {
            navContainer.scrollLeft = navContainer.scrollLeft + amount;
          }
          navContainer.setAttribute('data-is-moving', 'false');

        }, false);
      }
  }
};

/**
 * Save filter max-width to be applied to other elements
 */
var cor_filter_max_width = function() {
  // get first child of filters
  var filters = document.querySelectorAll('.js-filters');
  if (filters.length > 0) {
    for (var i = 0; i < filters.length; i++) {
      var first_child = filters[i].children[0];
      var first_child_width = first_child.offsetWidth;
      // set max-width on :root css variable
      document.documentElement.style.setProperty('--cor-filter-max-width', first_child_width + 'px');
    }
  }
}

// init
var ajax_containers = document.querySelectorAll('[data-cor-ajax-container]');
if (ajax_containers.length > 0) {
  for (var i = 0; i < ajax_containers.length; i++) {
    cor_filters(ajax_containers[i]);
  }
  document.addEventListener( 'DOMContentLoaded', cor_popular_filters );
  window.addEventListener('cor_ajax_complete', cor_popular_filters);
  cor_filter_max_width();
  document.addEventListener( 'DOMContentLoaded', cor_filter_max_width );
  window.addEventListener( 'resize', cor_filter_max_width );
  window.addEventListener( 'cor_ajax_complete', cor_filter_max_width );
}
